import React, { FC } from 'react';
import { css } from '@emotion/css';

export interface CalculatorResultItemProps {
  label: string;
  value: string | number;
}

const CalculatorResultItem: FC<CalculatorResultItemProps> = (props) => {
  const { label, value } = props;
  return (
    <li className={styles.root}>
      <span className={styles.label}>{label}</span>
      <span className={styles.value}>{value}</span>
    </li>
  );
};

const styles = {
  root: css`
    display: flex;
    justify-content: space-between;
    padding-bottom: 12px;
  `,
  label: css`
    font-weight: 400;
    font-size: 18px;
    line-height: 28px;
    color: rgba(51, 51, 51, 0.8);
  `,
  value: css`
    font-weight: 700;
    font-size: 18px;
    line-height: 28px;
    color: #333;
  `,
};

export default CalculatorResultItem;
